import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    tooltipPrefix: (resourceType: string | undefined) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Prefix for resource tooltip based on resource type */
            tooltipPrefix: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (resourceType: string | undefined) => { if (resourceType === "NotificationLayoutItemProjectName")
                        return __intl__.intl().formatMessage({ id: "NotificationCellFooter.tooltipPrefix.0?c=14bndfs8xpffs", defaultMessage: "Project: " }); if (resourceType === "NotificationLayoutItemShareName")
                        return __intl__.intl().formatMessage({ id: "NotificationCellFooter.tooltipPrefix.1?c=2gyw7vlqotolg", defaultMessage: "Share: " }); return __intl__.intl().formatMessage({ id: "NotificationCellFooter.tooltipPrefix.2?c=27k1wwwhf13t", defaultMessage: "" }); });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
